import { SnackbarComponent } from './../../../../shared/snackbar/snackbar.component';
import { Component, OnDestroy, OnInit, ViewChild, NgZone, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ConnectionDialogComponent } from '../../../../shared/dialog/connection-dialog/connection.dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ConnectionService } from '../../connection.service';
import { environment } from 'src/environments/environment';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { CustomPaginator } from './CustomPaginatorConfiguration';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { SpinnerService } from 'src/app/shared/spinner/spinner.service';
import { ClientPlatformService } from '../../../../client-platform/client-platform.service';
import { PermissionService } from 'src/app/core/services/permission.service';
import { AuthServiceService } from 'src/app/shared/services/auth-service.service';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { SmsService } from 'src/app/shared/services/sms-service.service';
import { QoutaPopupComponent } from 'src/app/shared/qouta-popup/qouta-popup.component';
import { ConnectionCollaborationComponent } from '../connection-collaboration/connection-collaboration/connection-collaboration.component';
import { ResourcePermissionService } from 'src/app/shared/services/resource-permission.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DeleteDialogComponent } from 'src/app/shared/delete-dialog/delete-dialog.component';
import { WidgetManager } from 'src/app/bloom/models/WidgetManager';
import { UIConfigService } from 'src/app/shared/services/UIConfigService';


interface snackBarValues {
  snackBarMessage: string;
  snackBarIcon: string;
  snackBarError: boolean;
  snackBarDuration: number;
}

@Component({
    selector: 'app-connection-listing',
    templateUrl: './connection-listing.component.html',
    styleUrls: ['./connection-listing.component.scss'],
    providers: [
        { provide: MatPaginatorIntl, useValue: CustomPaginator() }, // Here
    ],
    standalone: false
})
export class ConnectionListingComponent implements OnInit, OnDestroy {
  @ViewChild('connectionPaginator', { static: true })
  public connectionPaginator: MatPaginator | undefined;
  paramWorkSpaceId: string;
  workSpaceId: string;
  startIndex: number = 0;
  pageEvent: PageEvent;
  pageLimit: any = 20;
  pageIndex: any = 0;
  selectedConnectionView: string;
  snackBarObj: snackBarValues;
  connectionSearchField: any;
  tableSourceData: MatTableDataSource<any>;
  displayedColumns: string[] = ['number', 'icon', 'name', 'actions'];
  preAuthenticatedToken: any;
  spinner: boolean = false;
  profile: any;
  authError: boolean = false;
  showWorkspace: boolean = true;
  error = false;
  newTimerId: any = '';
  //flags
  isPaginator: boolean = false;
  private _searchMobile: boolean = false;
  paramToken: string;
  sharedConnections: any[] = [];
  isBrowser: boolean;
  alignment: string = 'flex-start';

  get searchMobile(): boolean {
    return this._searchMobile;
  }

  public set searchMobile(v: boolean) {
    this._searchMobile = v;
  }

  get router() {
    return this._router;
  }
  get snackBar() {
    return this._snackBar;
  }
  get dialog() {
    return this._dialog;
  }
  get connectionService() {
    return this._connectionService;
  }
  get clientPlatformService() {
    return this._clientPlatformService;
  }
  get route() {
    return this._route;
  }
  get spinnerService() {
    return this._spinnerService;
  }

  connectionListMeta: any;

  constructor(
    private themeService: ThemeService,
    public authService: AuthServiceService,
    public permission: PermissionService,
    public resourcePermissionService: ResourcePermissionService,
    private ngZone: NgZone,
    private _router: Router,
    private _snackBar: MatSnackBar,
    private _dialog: MatDialog,
    public _connectionService: ConnectionService,
    private _clientPlatformService: ClientPlatformService,
    private _route: ActivatedRoute,
    private _spinnerService: SpinnerService,
    private smsService: SmsService,
    private breakpointObserver: BreakpointObserver,
    public uic: UIConfigService,
    @Inject(PLATFORM_ID) platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    ) {
      this.isBrowser = isPlatformBrowser(platformId);
      if(!this.isBrowser) return;
      this.profile = this.authService.profile;
   }

  ngOnInit(): void {
    // this.spinner = true;
    if(!this.isBrowser) return;

    this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall]).subscribe(result => {
      this.alignment = result.matches ? 'center' : 'flex-start';
    });

    console.log("this.connectionService.selectedWorkSpace", this.connectionService.selectedWorkSpace)
    console.log("this.authService.loggedIn", this.authService.loggedIn)
    console.log("this.authService.profile", this.authService.profile)
    if (
      !this.connectionService.selectedWorkSpace &&
      !this.authService.loggedIn
    ) {
      this.authService.authCheck();
      this.authService.authCheckPositive.subscribe((authStatus) => {
        //if logged in
        if (authStatus) {
          this.preAuthenticatedToken =
            this.connectionService.getPreAuthenticatedTokenForEmail(
              this.authService.profile.email
            );
          this.spinner = true;
          console.log('logged in');
          this.themeService.loadTheme();
          this.themeService.getExistingTheme(this.authService.profile._id)
          .then((res: any) => {
            if (res?.data != null) {
              console.log(res);
              this.themeService.settings_Id = res?.data[0]._id;
              let theme = res.data[0].themeSetting.theme;
              this.themeService.setTheme(theme);
              this.themeService.currentLocale = res.data[0].localeSetting;
              this.themeService.textDirection =
                res.data[0].themeSetting.direction;
              if (res.data[0].themeSetting.direction == 'rtl') {
                this.themeService.enableDirMode('rtl');
              }
            }
          });
          this.spinner = false;
          console.log("form in auth before", this.connectionService.workSpaceId);
          this.initialize();
        } else {
          this.authError = true;
          this.spinner = false;
          return;
        }
      });
    } else if (this.connectionService.selectedWorkSpace) {
      this.initialize()
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.newTimerId);
    this.authService?.authCheckPositive?.unsubscribe();
  }
  trackByFn(index:number, item:any):any{
    return item || index
  }

  navigateToSignUp(){
    this.router.navigate(['sign-up']);
  }

  async initialize(fromWorkspace?: boolean) {
    if(!this.connectionService.workSpaceId) await this.connectionService.getWorkSpaceId();
    if (this.connectionService.selectedWorkSpace) {
      let token = this.connectionService.getPreAuthenticatedTokenForEmail(this.connectionService.selectedWorkSpaceMap.created_by);
      this.connectionService.checkClientType(this.workSpaceId || this.connectionService.selectedWorkSpace, token).catch((e) => {
        console.log(e);
      });
    }
    // if (!fromWorkspace && this.paramWorkSpaceId && this.paramWorkSpaceId != this.connectionService.workSpaceId) {
    //   this.showWorkspace = false;
    //   this.connectionService.workSpaceId = this.paramWorkSpaceId;
    //   this.workSpaceId = this.paramWorkSpaceId;
    //   if (this.paramToken) {
    //     this.connectionService.preAuthenticatedToken = this.paramToken;
    //     this.preAuthenticatedToken = this.paramToken;
    //   }
    // }
    this.preAuthenticatedToken =
      this.connectionService.setPreauthenticatedToken();
    console.log('TOKEN received', this.preAuthenticatedToken);
    // get workspace id
    // let workspaceId = await this.connectionService.getWorkSpaceId()
    // console.log("workspace id received", workspaceId);

    // this.listConnection();
    this.createConnectionListMeta()
    this.listSharedConnection();

    /*hide workspace dropdown if component used from CP*/
    if(this.clientPlatformService.clientType) this.showWorkspace = false;

    if(this.authService.loggedIn)this.connectionService.getBoxes();
    this.selectedConnectionView = 'view_list';
  }

  createConnectionListMeta(){
    if(!this.paramWorkSpaceId && !this.connectionService.selectedWorkSpace) return
    this.connectionListMeta = {
      alignment: this.alignment,
      listAttributes: [
        {
          "widgetType": "label",
          "columnName": "Id",
          "sortEnabled": false,
          "show_hide": false,
          "value": "_id",
          "dataType": "NA",
          "isColumnSelected": false,
          "name": "Id",
          "__id": "_id",
          "fieldType": "attribute"
        },
        {
          "widgetType": "label",
          "columnName": "#",
          "sortEnabled": false,
          "show_hide": false,
          "value": "__serial__",
          "dataType": "NA",
          "isColumnSelected": true,
          "name": "__serial__",
          "__id": "__serial__",
          "fieldType": "label"
        },
        {
          "__id": "options",
          "name": "Logo",
          "dataType": "string",
          "sortEnabled": false,
          "show_hide": false,
          "fieldType": "attribute",
          "widgetType": "image",
          "isColumnSelected": true,
          isDrillDown: true,
          nestedProperties: [
            {
              fieldType: "attribute",
              path: "box_logo_url",
              widgetType: "image",
              headerTitle: "Logo"
            }
          ]
        },
        {
          columnName: 'Status',
          dataType: 'NA',
          fieldType: 'attribute',
          filterable: true,
          name: 'Status',
          show_hide: false,
          sortEnabled: true,
          value: '',
          conditionalConfig: {
            enabled: true,
            attributeRelation: "", // if display value of this attribute depends on some attribute X, id of X comes here
            displayRules: [
              {compareValue: "DRAFT", operator: "=", result: "content_paste", tooltip: "Draft", color: "primary"},
              {compareValue: "ACTIVE", operator: "=", result: "check_circle", tooltip: "Active", color: "green"},
              {compareValue: "FAILED", operator: "=", result: "cancel", tooltip: "Failed", color: "red"}
            ]
          },
          widgetType: 'icon',
          __id: 'status',
          isColumnSelected: true
        },
        {
          "__id": "name",
          "name": "Connection Name",
          "dataType": "string",
          "sortEnabled": true,
          "show_hide": false,
          "fieldType": "attribute",
          "filterable": true,
          "widgetType": "label",
          "isColumnSelected": true
        },
        {
          "__id": "created_at",
          "name": "Created At",
          "dataType": "datetime",
          "sortEnabled": true,
          "show_hide": false,
          "fieldType": "attribute",
          "filterable": true,
          "widgetType": "label",
          "isColumnSelected": true
        },
        {
          "__id": "modified_at",
          "name": "Modified At",
          "dataType": "datetime",
          "sortEnabled": true,
          "show_hide": false,
          "fieldType": "attribute",
          "filterable":true,
          "widgetType": "label",
          "isColumnSelected": true
        },
        {
          columnName: 'View',
          dataType: 'NA',
          fieldType: 'icon',
          name: 'Explore connection',
          show_hide: false,
          sortEnabled: false,
          value: 'visibility',
          widgetType: 'icon',
          __id: 'view',
          isColumnSelected: !this.clientPlatformService.clientType ? true : false
        },
        {
          columnName: 'Edit',
          dataType: 'NA',
          fieldType: 'icon',
          name: 'Edit connection',
          show_hide: false,
          sortEnabled: false,
          value: 'edit',
          widgetType: 'icon',
          __id: 'edit',
          isColumnSelected: true
        },
        {
          columnName: 'Share',
          dataType: 'NA',
          fieldType: 'icon',
          name: 'Share connection',
          show_hide: false,
          sortEnabled: false,
          value: 'share',
          widgetType: 'icon',
          __id: 'share',
          isColumnSelected: !this.clientPlatformService.clientType ? true : false
        },
        {
          columnName: 'Clone',
          dataType: 'NA',
          fieldType: 'icon',
          name: 'Clone connection',
          show_hide: false,
          sortEnabled: false,
          value: 'content_copy',
          widgetType: 'icon',
          __id: 'clone',
          isColumnSelected: true
        },
        {
          columnName: 'Delete',
          dataType: 'NA',
          fieldType: 'icon',
          name: 'Delete connection',
          show_hide: false,
          sortEnabled: false,
          value: 'delete_outline',
          widgetType: 'icon',
          __id: 'delete',
          isColumnSelected: true,
          eventType: 'action',
          actionConfig: {
            action: 'resource-deletion',
            event: 'click'
          }
        }
      ],
      // dataHeaders: ["#", "Name"],
      defaultListSize: 10,
      hideTitle: true,
      filter: {
        "show": true,
        "filterEnabled": true,
        "operator": 'and',
        "options":{
          "isOuterOperatorSelectionDisabled": true,
          "isSupportGroupfilter": true
        },
        "filterItems": [
          {
            "attribute": "workspace_id",
            "operator": "=",
            "value": this.paramWorkSpaceId || this.connectionService.selectedWorkSpace,
            "dataType": "string",
            "filterType": "static_filter",
            "hidden": true
          }
        ]
      },
      sort:{
        show: true,
        sortEnabled: true,
        sortAttributes: [
          {
            attribute: "modified_at",
            order: "DESC",
            dataType: "datetime"
          }
        ]
      },
      type: 'listpanel',
      viewTypes: {
        "views": [
            "table",
            "card",
            "board"
        ],
        "defaultView": "table",
        "boardStatusColumn": "",
        "userCanChoose": !this.clientPlatformService.clientType ? true : false,
        "table": {
            "name": "table",
            "displayName": "Table",
            "userCanChoose": true,
            "icon": "list"
        },
        "card": {
            "name": "card",
            "displayName": "Card",
            "userCanChoose": true,
            "icon": "grid_on"
        },
        "board": {
            "name": "board",
            "displayName": "Board",
            "userCanChoose": false,
            "icon": "view_kanban"
        }
      },
      userFilterEnabled: true,
      userSortEnabled: true,
      boxId: 'starch',
      connectionId: "",
      baseMap: {
        "box_id": "mongodb",
        "base_id": ""
      },
      boxObjectId: 'connection',
      loadInitialData: true,
      boxConfigToken: environment.DB_BOX_TOKEN,
      pageSize: 10,
      paginationEnabled:true,
      paginationType: "pagebypage",
      id: "connection-listing",
      noCache: true,
      noDataMessage: "Create your first connection now!"
    };

    // this.connectionListMeta["listWidgetSet"] = this.getWidgetSet(this.connectionListMeta)
  }

  async rowClicked(data){
    console.log("connection action clicked", data)
    if (data.actionId == 'view') {
      this.exploreConnection(data.rowDataRaw)
    } else if (data.actionId == 'edit') {
      this.editConnectionData(data.rowDataRaw)
    } else if (data.actionId == 'share') {
      this.shareConnectionData(data.rowDataRaw)
    } else if (data.actionId == 'clone') {
      this.cloneconnection(data.rowDataRaw)
    }
    // let clickedObject = this.objects.find(obj => obj.name == data.data.name.value)
    // this.exploreObject(clickedObject.__id)
  }

  // ngOnInit(): void {
  //   console.log("in con list")
  // this.connectionService.checkClientType(this.workSpaceId).catch(e => {
  //     console.log(e);
  //   });
  //   //show intial connection table data. if empty hide table record and show select a app for new connection
  //   if (this.workSpaceId) { this.listConnection(); }
  //   // this.authService.userProfile.last_workspace = this.connectionService.workSpaceId;
  //   //get app data and set data into allboxes
  //   this.connectionService.getBoxes();
  //   //set default Value
  //   this.selectedConnectionView = 'view_list';
  // }

  //Common Snackbar function

  openSnackBar(snackBarObj: snackBarValues) {
    this._snackBar.openFromComponent(SnackbarComponent, {
      data: {
        message: snackBarObj.snackBarMessage,
        iconname: snackBarObj.snackBarIcon,
      },
      duration: snackBarObj.snackBarDuration,
      horizontalPosition: 'end',
    });
  }

  //User click on +Create button => select an app for new connection
  async createNewRecord(isZeroConnection: boolean = false) {
    this.spinner = true;
    // this.route.queryParamMap.subscribe((params) => {
    //   this.paramWorkSpaceId = params.get('workspaceid');
    //   if (this.paramWorkSpaceId) this.connectionService.selectedWorkSpace = this.paramWorkSpaceId
    //   this.paramToken = decodeURIComponent(params.get('authorization'));
    //   console.log('this.paramWorkSpaceId', this.paramWorkSpaceId);
    //   console.log("this.paramToken",this.paramToken);
    // });

    /*Handle the quota restriction for client types*/
    if (this.clientPlatformService.clientType && !this.smsService.planMap) {
      await this.authService.checkAndCreateUser({email: this.clientPlatformService.clientUserId || this.clientPlatformService.userEmail});
    }


    console.log("this.smsService.planMap",this.smsService.planMap);

    let eligibility = this.smsService.checkEligibility("CONNECTION");
    console.log("isEligible", eligibility);
    if(!eligibility.isEligible){
      let dialogRef = this.dialog.open(QoutaPopupComponent, {
            minWidth: "260px",
            height: "auto",
            data: {
              type: "CONNECTION"
            },
          });
      this.spinner = false;
      return ;
    }

    // if (this.paramWorkSpaceId != this.connectionService.workSpaceId) {
    //   this.connectionService.workSpaceId = this.paramWorkSpaceId;
    //   this.workSpaceId = this.paramWorkSpaceId;
    //   if (this.paramToken) {
    //     this.connectionService.preAuthenticatedToken = this.paramToken;
    //     this.preAuthenticatedToken = this.paramToken;
    //   }
    // }

    this.router.navigate(['connection/apps'], {
      // queryParams: {
      //   workspaceid: this.connectionService.workSpaceId,
      //   authorization: encodeURIComponent(
      //     this.connectionService.preAuthenticatedToken
      //   ),
      //   iszeroconnection: isZeroConnection,
      // },
    });
    this.spinner = false;
  }


  async listSharedConnection(){
    this.sharedConnections = await this.resourcePermissionService.getSharedResources(
      this.authService.profile._id,
      'connection'
    );
    console.log("shared connections : ",this.sharedConnections)
  }


  // user clicked edit button in connection table
  // hide connection table show edit connection
  editConnectionData(connection: any) {
    this.router.navigate(['connection/newconnection'], {
      queryParams: {
        workspaceid: connection.workspace_id || this.paramWorkSpaceId || this.connectionService.workSpaceId,
        authorization: encodeURIComponent(
          this.connectionService.preAuthenticatedToken
        ),
        isEdit: true,
      },
      state: { connection: connection },
    });
  }

  async exploreConnection(connection: any) {
    this.spinnerService.show();
    try {
    var conn = await this.connectionService.getConnection( connection._id,'','preauthenticated_token');
    } catch(e) {
      console.log("Error while getting connection", e)
      this.spinner = false;
      this.spinnerService.hide();
      let msg = 'Could not establish the connection. Please Disable Authorization and Re-Authorize the connection'
      this.clientPlatformService.openErrorActionSnackBar(msg, 'Re-Authorize', () => {
        this.editConnectionData(connection)
      })
    }
    this.spinnerService.hide();
    if(conn){
      this.router.navigate(['connection/connectionexplorer'], {
        state: {
          connection: conn,
          workspaceId: this.paramWorkSpaceId || this.connectionService.workSpaceId
         },
      });
    }
  }
  //Toogle between card view or list view
  // connectionListToggle() {
  //   if (this.selectedConnectionView == 'view_list') {
  //     this.selectedConnectionView = 'view_module';
  //   } else {
  //     this.selectedConnectionView = 'view_list';
  //   }
  // }

  //Connection Pagination
  // pageChanged($event) {
  //   console.log($event);
  //   this.pageIndex = $event.pageIndex;
  //   this.pageLimit = $event.pageSize;
  //   sessionStorage.setItem('_AWConnectionListPageLimit', this.pageLimit);
  //   sessionStorage.setItem('_AWConnectionListPageIndex', this.pageIndex + 1);
  //   // this.listConnection(this.pageIndex + 1, this.pageLimit);
  // }

  async cloneconnection(element, index?){
    console.log(element)
    let payload = JSON.parse(JSON.stringify(element))
    payload.name = JSON.parse(JSON.stringify("Copy of " + element.name))
    delete payload._id;
    if(payload.code){
      payload.code = "copy_of_" + payload.code
    }
    console.log(payload)
    let response
    try{
      response = await this.connectionService.createConnection(payload, this.workSpaceId);
    }catch(e){
      console.log(e)
    }
    // this.tableSourceData.data.splice(index + 1, 0, response.connection)
    // let list = JSON.parse(JSON.stringify(this.tableSourceData.data))
    // this.tableSourceData.data = [];
    // this.tableSourceData.data = JSON.parse(JSON.stringify(list))
    // console.log(index, this.tableSourceData, response)
    this._snackBar.open('Connection ' + element.name + ' is succesfully cloned', "", {duration: 3000});
  }

  async shareConnectionData(element){
    console.log("Connection to be Shared : ",element);
    let dialogRef = this.dialog.open(ConnectionCollaborationComponent, {
      width: '90vw',
      height: '90vh',
      panelClass: "collabdiolog",
      data: {
        resource: element,
        resourceType: 'connection',
        workspaceMap: this.connectionService.selectedWorkSpaceMap
      },
    });
    var diologResult = await dialogRef.afterClosed().toPromise();
  }
}
